import React, { MouseEvent, ReactNode } from 'react';
import { Text } from '@/components/typography';

export interface OffersNotFoundProps {
  className?: string;
  children?: ReactNode;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void | undefined;
}

const OffersNotFound = ({ children, ...props }: OffersNotFoundProps) => {
  return (
    <Text align="center" size="md">
      Ofertas não encontradas.
    </Text>
  );
};

export default OffersNotFound;
